import { render, staticRenderFns } from "./SafeHome.vue?vue&type=template&id=b893b874&scoped=true&"
import script from "./SafeHome.vue?vue&type=script&lang=js&"
export * from "./SafeHome.vue?vue&type=script&lang=js&"
import style0 from "./SafeHome.vue?vue&type=style&index=0&id=b893b874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b893b874",
  null
  
)

export default component.exports